<mat-drawer-container class="app-container m-2">
    <mat-drawer #matDrawer [mode]="'side'" [opened]="true" class="app-side-nav" [ngClass]="{ collapsed: isCollapseNav }">
        <app-side-nav (collapseStatusChange)="onCollapseStatusChange($event)"></app-side-nav>
    </mat-drawer>
    <mat-drawer-content #matDrawerContent (scroll)="matDrawerContentScroll($event)" [style.margin-left.px]="isCollapseNav ? 70 : 220" class="drawer-content">
        <app-header (open)="matDrawer.toggle()" *ngIf="!isWelcomeScreen"></app-header>
        <div [ngClass]="{ 'main-body': !isWelcomeScreen }" class="px-2">
            <router-outlet></router-outlet>
        </div>
    </mat-drawer-content>
</mat-drawer-container>
